import TaskManagerEditDto from './TaskManagerEditDto';

export class DataCleanTaskEditDto extends TaskManagerEditDto {
    constructor() {
        super();

        /** @type {number} */
        this.inputMeasurement = null;

        /** @type {number} */
        this.outputMeasurement = null;

        /** @type {boolean} */
        this.outlierRemoval = null;

        /** @type {boolean} */
        this.skewnessCorrection = null;

        /** @type {number} */
        this.optimizationPipelineLog = null;
    }

    /**
     * @typedef {Object} _DataCleanTaskEditDtoProps
     * @property {number} inputMeasurement
     * @property {number} outputMeasurement
     * @property {boolean} outlierRemoval
     * @property {boolean} skewnessCorrection
     * @property {number} optimizationPipelineLog
     *
     * @typedef {import("./TaskManagerEditDto").TaskManagerEditDtoProps & _DataCleanTaskEditDtoProps} DataCleanTaskEditDtoProps
     */
    /**
     *
     * @param {DataCleanTaskEditDtoProps} props
     * @returns {DataCleanTaskEditDto}
     */
    setup(props) {
        super.setup(props);

        this.inputMeasurement = props.inputMeasurement;
        this.outputMeasurement = props.outputMeasurement;
        this.outlierRemoval = props.outlierRemoval || false;
        this.skewnessCorrection = props.skewnessCorrection || false;
        this.optimizationPipelineLog = props.optimizationPipelineLog;

        return this;
    }
}

export default DataCleanTaskEditDto;